import NorthSquare1 from '../Northsquare/NorthSquare (1).webp'
import NorthSquare2 from '../Northsquare/NorthSquare (2).webp'
import NorthSquare3 from '../Northsquare/NorthSquare (3).webp'
import NorthSquare4 from '../Northsquare/NorthSquare (4).webp'
import NorthSquare5 from '../Northsquare/NorthSquare (5).webp'
import NorthSquare6 from '../Northsquare/NorthSquare (6).webp'
import NorthSquare7 from '../Northsquare/NorthSquare (7).webp'
import NorthSquare8 from '../Northsquare/NorthSquare (8).webp'
import NorthSquare9 from '../Northsquare/NorthSquare (9).webp'
import NorthSquare10 from '../Northsquare/NorthSquare (10).webp'


const NorthSquareimages =[
NorthSquare1,NorthSquare2,NorthSquare3,NorthSquare4,NorthSquare5,NorthSquare6,NorthSquare7,NorthSquare8,NorthSquare9,NorthSquare10
]

export default NorthSquareimages;